import { Directive, Input, ElementRef, ChangeDetectorRef, HostListener } from '@angular/core';
import { ErrorMessagesService } from './error-messages.service';
import { IErrorDefinition } from '../interfaces/error-definition.interface';
import { ResponsiveService } from '../services/responsive.service';
import { Subject } from 'rxjs';

@Directive()
export abstract class InputWithErrorsDirective {
  @Input()
  public inputLabel: string;

  @Input()
  public announceError = 0;

  public errorMessageVisible = true;

  public constructor(
    private readonly errorMessages: ErrorMessagesService,
    private readonly elementRef: ElementRef,
    public readonly responsiveService: ResponsiveService,
    protected changeDetectorRef: ChangeDetectorRef
  ) {}

  public errorSubject = new Subject<number>();

  public submitNativeForm(): void {
    if (!this.responsiveService.isIeOrEdge) {
      this.elementRef.nativeElement.closest('form')?.querySelector('[type=submit]')?.click();
    }
  }

  public getErrorMessage(error: IErrorDefinition): string {
    return this.errorMessages.getMessage(error, this.inputLabel);
  }

  @HostListener('focus')
  reannounceOnFocus() {
    this.errorMessageVisible = false;
    this.announceError++;
    this.errorSubject.next(this.announceError);
    this.changeDetectorRef.detectChanges();
    setTimeout(() => {
      this.errorMessageVisible = true;
      this.changeDetectorRef.detectChanges();
    }, 10);
  }
}
